import { page01Example } from '../../../../fixtures/page01/design-data';
import { PlatformHeader } from '../../../shared/platform/PlatformHeader';
import { TitleBackdrop } from '../../../shared/platform/TitleBackdrop';
import { Icon } from '../../../shared/ui/Primitives';

export function Page01Header({ explain }: { explain: (title: string, body: string) => void }) {
  return (
    <>
      <PlatformHeader activePage="overview" explain={explain} />
      <section id="Z02" className="p01-titlebar">
        <TitleBackdrop />
        <div className="p01-title-line">
          <h1>{page01Example.context.title}</h1>
          <span>National Overview</span>
        </div>
        <p>全域感知 · 风险洞察 · 统一指挥 · 科学决策</p>
        <span className="p01-authority">
          <Icon name="info" />
          只读研判 · 该读取结果不构成操作授权
        </span>
      </section>
    </>
  );
}
